export default {
    path: 'sys_employee',
    name: 'sys_employee',
    component: r => require.ensure([], () => r(require('./index.vue')), 'sys_employee'),
    redirect: {name: 'sys_employee_list'},
    children: [
        {
            path: 'sys_employee_list',
            name: 'sys_employee_list',
            component: r => require.ensure([], () => r(require('./list.vue')), 'sys_employee_list'),
        }
    ]
}
